import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState('vans');

  return (
    <header className="header">
      <div className="top-bar">
        <Link to="/" className="header__logo-link">
          <span className="header__logo">Vanir Motor Group</span>
        </Link>
        <div className="desktop-menu-chips">
          {['cars', 'vans', 'trucks'].map(cat => (
            <Link
              key={cat}
              to={`/${cat}`}
              className={`desktop-chip ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat.charAt(0).toUpperCase() + cat.slice(1)}
            </Link>
          ))}
        </div>
        <div className="header-actions">
          <a
            href="tel:01516731916"
            className="contact-icon"
            aria-label="Call us"
          >
            <FontAwesomeIcon icon={faPhone} fixedWidth />
          </a>
          <a
            href="https://wa.me/447496004554"
            className="whatsapp-icon"
            aria-label="WhatsApp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faWhatsapp} fixedWidth />
          </a>
          <button
            className="header__hamburger"
            onClick={() => setMobileMenuOpen(true)}
            aria-label="Open menu"
          >
            &#9776;
          </button>
        </div>
      </div>

      <div className="desktop-menu-content">
        {activeCategory === 'cars' && (
          <nav className="desktop-submenu">
            <Link to="/cars/used">Used Cars</Link>
            <Link to="/cars/new">New Cars</Link>
            <Link to="/cars/finance">Car Finance</Link>
            <Link to="/cars/leasing">Car Leasing</Link>
            <Link to="/cars/reviews">Car Reviews</Link>
          </nav>
        )}
        {activeCategory === 'vans' && (
          <nav className="desktop-submenu">
            <Link to="/vans/used">Used Vans</Link>
            <Link to="/vans/new">New Vans</Link>
            <Link to="/vans/finance">Van Finance</Link>
            <Link to="/vans/leasing">Van Leasing</Link>
            <Link to="https://vanbuyersuk.com">Sell Your Van</Link>
            <Link to="/vans/reviews">Van Reviews</Link>
          </nav>
        )}
        {activeCategory === 'trucks' && (
          <nav className="desktop-submenu">
            <Link to="/trucks/used">Used Trucks</Link>
            <Link to="/trucks/new">New Trucks</Link>
            <Link to="/trucks/finance">Truck Finance</Link>
            <Link to="/trucks/leasing">Truck Leasing</Link>
            <Link to="https://truckbuyersuk.com">Sell Your Truck</Link>
          </nav>
        )}
      </div>

      {/* Mobile drawer */}
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay">
          <div className="mobile-menu-header">
            <button
              className="mobile-menu-close"
              onClick={() => setMobileMenuOpen(false)}
              aria-label="Close menu"
            >
              &times;
            </button>
            <div className="mobile-menu-chips">
              {['cars', 'vans', 'trucks'].map(cat => (
                <button
                  key={cat}
                  className={`mobile-chip ${activeCategory === cat ? 'active' : ''}`}
                  onClick={() => setActiveCategory(cat)}
                >
                  {cat.charAt(0).toUpperCase() + cat.slice(1)}
                </button>
              ))}
            </div>
          </div>
          <div className="mobile-menu-content">
            {activeCategory === 'cars' && (
              <>
                <Link to="/cars/used" onClick={() => setMobileMenuOpen(false)}>Used Cars</Link>
                <Link to="/cars/new" onClick={() => setMobileMenuOpen(false)}>New Cars</Link>
                <Link to="/cars/finance" onClick={() => setMobileMenuOpen(false)}>Car Finance</Link>
                <Link to="/cars/leasing" onClick={() => setMobileMenuOpen(false)}>Car Leasing</Link>
                <Link to="/car-search" onClick={() => setMobileMenuOpen(false)}>Buy a Car Online</Link>
                <Link to="/cars/reviews" onClick={() => setMobileMenuOpen(false)}>Car Reviews</Link>
              </>
            )}
            {activeCategory === 'vans' && (
              <>
                <Link to="/vans/used" onClick={() => setMobileMenuOpen(false)}>Used Vans</Link>
                <Link to="/vans/new" onClick={() => setMobileMenuOpen(false)}>New Vans</Link>
                <Link to="/vans/finance" onClick={() => setMobileMenuOpen(false)}>Van Finance</Link>
                <Link to="/vans/leasing" onClick={() => setMobileMenuOpen(false)}>Van Leasing</Link>
                <Link to="/van-search" onClick={() => setMobileMenuOpen(false)}>Sell Your Van</Link>
                <Link to="/vans/reviews" onClick={() => setMobileMenuOpen(false)}>Van Reviews</Link>
              </>
            )}
            {activeCategory === 'trucks' && (
              <>
                <Link to="/trucks/used" onClick={() => setMobileMenuOpen(false)}>Used Trucks</Link>
                <Link to="/trucks/new" onClick={() => setMobileMenuOpen(false)}>New Trucks</Link>
                <Link to="/trucks/finance" onClick={() => setMobileMenuOpen(false)}>Truck Finance</Link>
                <Link to="/trucks/leasing" onClick={() => setMobileMenuOpen(false)}>Truck Leasing</Link>
              </>
            )}
            <hr />
            <Link to="/about" onClick={() => setMobileMenuOpen(false)}>About Us</Link>
            <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>Contact Us</Link>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
